<template>
  <main id="content" class="layout-content">
    <div class="container">
      <router-link to="/" class="back-link font-bold font-bai">{{$t('app.Accueil')}}</router-link>
      <div class="c404-500 text-center font-bai">
        <img class="i404-500" src="../assets/images/404.svg" alt="404" />
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "Error400Page"
};
</script>
